import { IComponentOptions } from "angular";
import { IModalService } from "angular-ui-bootstrap";
import { GtmhubController } from "@gtmhub/core";
import { IApiPermission, UserAction } from "@gtmhub/sessions";
import { Principal, defaultUserActionSet } from "./models";

export type PermissionPrincipalBindings = {
  userActions?: UserAction[];
  permission: IApiPermission;
  principal: Principal;
  check(permission: IApiPermission, option: UserAction): void;
  removePermissions(permission: IApiPermission): void;
  canUnselectAction(permission: IApiPermission, option: UserAction): boolean;
  canRemovePrincipal(permission: IApiPermission): boolean;
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface PermissionPrincipalCtrl extends PermissionPrincipalBindings {}
export class PermissionPrincipalCtrl extends GtmhubController {
  defaultSet: UserAction[] = defaultUserActionSet();
  disabledAutoCloseDropdown = false;
  public static $inject = ["$uibModal"];
  constructor(private $uibModal: IModalService) {
    super();
  }

  openWhoIsInRoleModal(permission: IApiPermission): void {
    this.disabledAutoCloseDropdown = true;
    this.$uibModal
      .open({
        windowClass: "medium-small included-in-permission",
        component: "includedInPermission",
        resolve: {
          principalId: () => permission.principalId,
          principalKind: () => permission.principalKind,
        },
      })
      .closed.then(() => {
        this.disabledAutoCloseDropdown = false;
      });
  }
}

export const PermissionPrincipalComponent: IComponentOptions = {
  templateUrl: require("./permission-principal.html"),
  controller: PermissionPrincipalCtrl,
  bindings: {
    permission: "=",
    principal: "=",
    userActions: "=?",
    check: "&",
    removePermissions: "&",
    canUnselectAction: "&",
    canRemovePrincipal: "&",
  },
};
